import React from 'react';
import destionation from '@src/assets/destination.svg';
import { NewMapProps } from './types';
import { Marker } from '@react-google-maps/api';
import { ArcDroneMarker } from '@src/core/controllers';

const NewMap: React.FC<NewMapProps> = (props) => {
  const { order } = props;

  return (
    <React.Fragment>
      <Marker 
        position={{ 
          lat: Number(order.deliveryLocation.latitude),  
          lng: Number(order.deliveryLocation.longitude), 
        }} 
        icon={{ 
          url: destionation,  
          scaledSize: new window.google.maps.Size(100, 50),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(17, 44),  
        }} />
      
      {order.drone && order.drone.latitude && order.drone.longitude && (
        <ArcDroneMarker.idle
          position={{
            lat: Number(order.drone.latitude),
            lng: Number(order.drone.longitude),
          }}
        />
      )}
    </React.Fragment>
  );
};

export default NewMap;